import router from '../../router'

var mouseX
var mouseY
var deltaX
var deltaY

const actions = {  	  	

  	// EVENT HANDLERS

  	async buildingHoverEvent({rootState, dispatch, commit}, graphic) {
  		dispatch('buildingHoverHighlight', graphic)
  	}, 

  	async buildingClickEvent({rootState, dispatch, commit, getters}, graphic) {
  		//console.log("Building Clicked")
  		let bldgAlpha 	= graphic.attributes['Buildings.SpaceNumLetter']
  		//let building 	= getters.getBuilding(bldgAlpha)
  		dispatch('selectBuilding', bldgAlpha)  		
  	}, 	

  	roomHoverEvent({rootState}, graphic) {
  		const hoverhighlightLayer = rootState.mapFunctions.stateMap.getLayer('hoverhighlightlayer')
  		hoverhighlightLayer.clear()
  		let hGraphic  = graphic.clone()
  		hGraphic.setSymbol(rootState.mapSymbols.roomHoverSymbol)
		hoverhighlightLayer.add(hGraphic)
  	},

  	async roomClickEvent({rootState, dispatch, getters, commit}, event) {  
  		//console.log("roomClickEvent")		
  		const highlightLayer = rootState.mapFunctions.stateMap.getLayer('highlightlayer')
  		let roomKey 	= event.graphic.attributes['ROOMEXT.roomKey']

  		if (!roomKey) {
  			// This is a null room
  			return
  		}

  		let bldgAlpha 	= roomKey.split('+')[0]
  		let roomNumber  = roomKey.split('+')[1]
  		let selectedRoom = rootState.space.selectedRoom
  		
  		// Determine Multi-Selection
  		let multiSelect = event.ctrlKey ? true : false 

  		// Get room Object 
  		let room = await getters.getRoom(roomKey)	// Get from Local buildingRooms
  		
  		if (multiSelect) { 
  			console.log("multiSelect Click")

  			// If there is a room already selected, clone it, add it to the array
  			if (selectedRoom) {
  				let newRoom = { ...selectedRoom } // object copy
  				commit('setSelectedRoom', null)	
  				rootState.mapFunctions.clearGraphics('highlightlayer')
  				dispatch('addToMultiSelectRoomArray', newRoom)
  			}

  			// Add room to MultiSelectRoomArray and Highlight
  			dispatch('addToMultiSelectRoomArray', room)
  			
  		} else { 
  			// Normal single selection  			

  			// If this room is already selected, clear the selection.
  			if (selectedRoom && selectedRoom.number == roomNumber) {
  				console.log("Same Room.  Deselecting")
  				commit('setSelectedRoom', null)
  				highlightLayer.clear()
  				return
  			}
  			commit('updateSelectionCentering', false)
  			dispatch('fetchFullRoom', {bldgAlpha: bldgAlpha, number: roomNumber}) // Needed for child tables
			commit('updateBulkRoomEditSideBar', false)

  			// Clear Multiselect Array, Select Room and Highlight
  			commit('clearMultiSelectRoomArray')
  			//dispatch('selectRoom', room)
  			//dispatch('highlightRoom', event.graphic)


  		}
		
		// Update Route
		// This needs redundant navigation protection
		//router.push({ name: 'highlightRoom', params: { bldg: bldgAlpha, room:room.number }})
  	},
}

export default {
	actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/mapEvents.js